import styled from "styled-components";
import { Tabs } from "react-bootstrap";

export const TabsContainer = styled(Tabs)`
  padding-right: 100px;
  border-bottom: 1px solid var(--blue-color-dark);
  .nav-link {
    margin-bottom: 0px !important;
    color: var(--blue-color-dark);
  }
  .active {
    border-bottom: 3px solid var(--primary-color) !important;
    color: var(--primary-color) !important;
  }
  button {
    background: transparent !important;
    border: none !important;
  }
  @media screen and (max-width: 768px) {
    padding-right: 40px;
  }
  @media screen and (max-width: 576px) {
    padding-right: 10px;
  }
`;
